import styled from "styled-components";
import "@fontsource/space-grotesk";

export const ContainerProjects = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    padding: 150px 0;

    @media screen and (max-width: 768px) {
        padding: 100px 0;
    }

    @media screen and (max-width: 480px) {
        padding: 50px 0;
    }
`;

export const SubContainerProjects = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    @media screen and (max-width: 630px) {    
        flex-direction: column;
        align-items: baseline;
    }
`;

export const SubTitle = styled.span`
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 700;
    color: ${props => props.theme.colors.text};
    font-size: 40px;

    @media screen and (max-width: 468px) {    
        font-size: 35px;
    }

    @media screen and (max-width: 320px) {    
        font-size: 30px;
    }
`;

export const ButtonSeeMore = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    background-color: ${props => props.theme.colors.background};
    border: 1px solid ${props => props.theme.colors.text};
    height: 30px;
    border-radius: 5px;
    transition: background-color 0.3s, border 0.3s;

    &:hover, &:focus {
        background-color: rgba(55, 216, 146, 0.2);
        border: 1px solid #37D892;
    }

    @media screen and (max-width: 480px) {
        width: 100%;
    }
`;

export const TextSeeMore = styled.span`
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 700;
    color: ${props => props.theme.colors.text};
    font-size: 15px;
`;

export const ContainerAllProjects = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;

    @media screen and (max-width: 768px) {
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }

    @media screen and (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`;

export const Project = styled.div`
    display: flex;
    background: ${props => props.theme.colors.background};
    box-shadow: ${props => props.theme.colors.shadow};
    flex-direction: column;
    border-radius: 20px;
    transition: transform 0.3s, box-shadow 0.3s;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
`;

export const BoxImage = styled.div`
    display: flex;
    background: #E6E9F0;
    height: 200px;
    justify-content: center;
    align-items: center;
    border-radius: 20px 20px 0 0;

    @media screen and (max-width: 480px) {
        height: 150px;
    }
`;

export const Image = styled.img`
    display: flex;
    height: 87%;
`;

export const ContainerTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 30px;

    @media screen and (max-width: 480px) {
        flex-direction: column;
        align-items: flex-start;
        padding: 20px;
    }
`;

export const SubContainerTitle = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`;

export const TitleProject = styled.span`
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 500;
    color: ${props => props.theme.colors.text};
    font-size: 25px;

    @media screen and (max-width: 480px) {
        font-size: 20px;
    }
`;
export const Description = styled.span`
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 500;
    color: ${props => props.theme.colors.secundary};
    margin: 20px 30px;
    text-align: justify;
    hyphens: auto;
    word-spacing: -0.05em;
    padding-bottom: 30px;
    min-height: 175px; /* Alteração aqui */

    @media screen and (max-width: 480px) {
        margin: 0 20px;
        height: auto; /* Deixar automático em telas menores */
    }
`;


export const Tools = styled.span`
    margin-top: 30px;
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 400;
    color: ${props => props.theme.colors.secundary};
    margin: 20px 30px 30px;
    display: block;
    line-height: 1.5;

    @media screen and (max-width: 480px) {
        margin: 20px 20px 30px;
    }
`;